module.exports = __webpack_public_path__ + "static/media/userAvatarGreen.522439d0.svg";